import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

function HomePage() {
  useEffect(() => {
    setTimeout(() => {
      document.body.classList.add('page-loaded');
      document.querySelectorAll('.fade-in').forEach(element => {
        element.classList.add('visible');
      });
    }, 100);

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new window.IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('.section, .step-item, .step-icon, .footer-column').forEach(element => {
      observer.observe(element);
    });

    return () => {
      observer.disconnect();
      document.body.classList.remove('page-loaded');
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="home-container">
      <div className="page-transition"></div>
      <div className="hero-section section">
        <div className="content-wrapper">
          <h1 className="hero-title fade-in">
            <span className="hero-title-line delay-1">Fast, Reliable Market</span>
            <span className="hero-title-line delay-2">Research</span>
            <span className="hero-title-line delay-3">Powered with <span className="transo-badge">Transo</span></span>
          </h1>
          <p className="hero-subtitle fade-in delay-3">
            Empowering Startups and SMEs with affordable, data-driven insights.
          </p>
          <div className="button-container fade-in delay-3">
            <Link to="/app" className="cta-button primary-button">Get Your Free Report</Link>
            <button onClick={() => scrollToSection('how-it-works')} className="cta-button secondary-button">Learn More</button>
          </div>
        </div>
      </div>
      <div className="how-it-works section" id="how-it-works">
        <h2 className="section-title fade-in">How It Works</h2>
        <div className="steps-container">
          <div className="step-item">
            <div className="step-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 5v14M5 12h14"/>
              </svg>
            </div>
            <h3 className="step-title">Define your target market</h3>
            <p className="step-description">Specify your industry, target audience, and research objectives.</p>
          </div>
          <div className="step-item">
            <div className="step-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 12H4"/>
              </svg>
            </div>
            <h3 className="step-title">AI gathers and analyzes the data</h3>
            <p className="step-description">Our AI processes vast amounts of market data in real-time.</p>
          </div>
          <div className="step-item">
            <div className="step-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 6L9 17l-5-5"/>
              </svg>
            </div>
            <h3 className="step-title">Receive your market research report</h3>
            <p className="step-description">Get comprehensive insights delivered to your inbox.</p>
          </div>
        </div>
      </div>
      <footer className="footer section">
        <div className="footer-content">
          <div className="footer-columns">
            <div className="footer-column fade-in">
              <h3 className="footer-title">INFORMATION</h3>
              <ul className="footer-links">
                <li><a href="#">About Us</a></li>
                <li><a href="#">Contact Us</a></li>
              </ul>
            </div>
            <div className="footer-column fade-in delay-1">
              <h3 className="footer-title">CUSTOMER SERVICE</h3>
              <ul className="footer-links">
                <li><a href="#">Privacy Policy</a></li>
                <li><a href="#">Shipping Policy</a></li>
                <li><a href="#">Exchange And Return</a></li>
                <li><a href="#">FAQ</a></li>
              </ul>
            </div>
            <div className="footer-column fade-in delay-2">
              <h3 className="footer-title">NEWSLETTER SIGN UP</h3>
              <p className="newsletter-text">Sign up for exclusive updates, new arrivals & insider only discounts</p>
              <form className="newsletter-form">
                <div className="form-group">
                  <input type="email" placeholder="enter your email address" className="newsletter-input" />
                  <button type="submit" className="newsletter-submit">SUBMIT</button>
                </div>
              </form>
              <div className="social-links">
                <a href="#" className="social-link"><i className="fab fa-facebook-f"></i></a>
                <a href="#" className="social-link"><i className="fab fa-instagram"></i></a>
                <a href="#" className="social-link"><i className="fab fa-tiktok"></i></a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage; 